import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SubTitle, Div, FormItem } from 'ui';
import { Col, Row, Checkbox } from 'antd';
import { injectIntl } from 'react-intl';

const StyledFormItem = styled(FormItem)`
  label {
    width: 100%;
    font-size: 16px;
  }
  
  margin-bottom: 50px;
`;

const SpecialHandlingTransport = ({
  intl,
  data,
  form,
  disabled,
}) => {
  form.getFieldDecorator('specialTransport', {
    initialValue: {
      isDeliveryAppointment: data?.isDeliveryAppointment || null,
      isInsideDelivery: data?.isInsideDelivery || null,
      isLiftGate: data?.isLiftGate || null,
      isResidential: data?.isResidential || null,
    },
  });
  const isDeliveryAppointmentValidator =
    form.getFieldDecorator('isDeliveryAppointment', {
      // when MW give null, this has to stay null, not false so we default always to null
      initialValue: data?.isDeliveryAppointment || null,
      valuePropName: 'checked',
    });

  const isInsideDeliveryValidator = form.getFieldDecorator('isInsideDelivery', {
    // when MW give null, this has to stay null, not false so we default always to null
    initialValue: data?.isInsideDelivery || null,
    valuePropName: 'checked',
  });


  const isLiftGateValidator = form.getFieldDecorator('isLiftGate', {
    // when MW give null, this has to stay null, not false so we default always to null
    initialValue: data?.isLiftGate || null,
    valuePropName: 'checked',
  });


  const isResidentialValidator = form.getFieldDecorator('isResidential', {
    // when MW give null, this has to stay null, not false so we default always to null
    initialValue: data?.isResidential || null,
    valuePropName: 'checked',
  });

  const onSpecialTransportChange = (id, e) => {
    const values = form.getFieldValue('specialTransport');
    form.setFieldsValue({
      specialTransport: {
        ...values,
        [id]: e.target.checked,
      },
    });
  };

  return (
    <Div marginTop={45}>
      <SubTitle>
        {intl.formatMessage({ id: 'order.specialHandlingTransport.title' })}
      </SubTitle>
      <Row type='flex' gutter={16} marginRight={0}>
        <Col lg={6} md={6} sm={12} xs={24}>
          <StyledFormItem>
            {isLiftGateValidator(
              <Checkbox
                onChange={v => onSpecialTransportChange('isLiftGate', v)}
                disabled={disabled}
              >
                {`${intl.formatMessage(
                  { id: 'order.specialHandlingTransport.liftGate' },
                )}`}
              </Checkbox>,
            )}
          </StyledFormItem>
        </Col>
        <Col lg={6} md={6} sm={12} xs={24}>
          <StyledFormItem>
            {isInsideDeliveryValidator(
              <Checkbox
                onChange={v => onSpecialTransportChange('isInsideDelivery', v)}
                disabled={disabled}
              >
                {`${intl.formatMessage(
                  { id: 'order.specialHandlingTransport.insideDelivery' },
                )}`}
              </Checkbox>,
            )}
          </StyledFormItem>
        </Col>
        <Col lg={6} md={6} sm={12} xs={24}>
          <StyledFormItem>
            {isResidentialValidator(
              <Checkbox
                onChange={v => onSpecialTransportChange('isResidential', v)}
                disabled={disabled}
              >
                {`${intl.formatMessage(
                  { id: 'order.specialHandlingTransport.residential' },
                )}`}
              </Checkbox>,
            )}
          </StyledFormItem>
        </Col>
        <Col lg={6} md={6} sm={12} xs={24}>
          <StyledFormItem>
            {isDeliveryAppointmentValidator(
              <Checkbox
                onChange={v => onSpecialTransportChange('isDeliveryAppointment', v)}
                disabled={disabled}
              >
                {`${intl.formatMessage(
                  { id: 'order.specialHandlingTransport.callForDeliveryAppointment' },
                )}`}
              </Checkbox>,
            )}
          </StyledFormItem>
        </Col>
      </Row>
    </Div>
  );
};

SpecialHandlingTransport.propTypes = {
  intl: PropTypes.object,
  data: PropTypes.object,
  form: PropTypes.object,
  disabled: PropTypes.bool,
};

export default injectIntl(SpecialHandlingTransport);

